import React from 'react';
import { Device } from 'DeviceUtils';
import { t } from 'Locale';
import { Button, Hr, Icon, ModalHeader } from 'LocalGluons';
import { SafeAreaView, ImageBackground } from 'react-native';
import { ConsentDefinitions } from '@24i/st-api-connector';
import { defaultStyles, landscapeStyles } from './VoyoPromoScene.jss';

interface VoyoPromoSceneProps {
    onContinue: () => void;
    consentsDefinition: any;
}

const VoyoPromoScene = ({
    onContinue,
    consentsDefinition
}: VoyoPromoSceneProps): React.ReactElement => {
    const styles = Device.isTabletOrWeb ? landscapeStyles : defaultStyles;

    return (
        <ImageBackground
            source={{
                uri: Device.isTabletOrWeb
                    ? consentsDefinition.infoImageUrlLandscape
                    : consentsDefinition.infoImageUrlPortrait
            }}
            style={defaultStyles.backgroundImage}
        >
            <SafeAreaView style={defaultStyles.container}>
                <Button
                    style={{
                        button: styles.buttonContinue,
                        text: styles.textContinue
                    }}
                    title={t('COMMON.CONTINUE')}
                    onPress={onContinue}
                />
            </SafeAreaView>
        </ImageBackground>
    );
};

export default VoyoPromoScene;
